
import $ from 'jquery';
export const convertJSON = () => {
  $('body').on('click', '#convert_from_json', () => {
    const value = $('#convertthis').val();

    $('#convert_result').val(JSON.parse(decodeURIComponent(value)));
  });
  $('body').on('click', '#convert_to_json', () => {
    const value = $('#convertthis').val();

    $('#convert_result').val(encodeURIComponent(JSON.stringify(value)));
  });

  return `<div class="container">
        <div class="row">
        <div class="col">
            <textarea id="convertthis" class="form-control" width="100%" style="height:600px"></textarea>
            
            <button id="convert_to_json" class="btn">Convert to JSON</button>
            <button id="convert_from_json" class="btn">Convert from JSON</button>
            <textarea id="convert_result" class="form-control" width="100%" style="height:600px"></textarea>
        </div>
        </div>
        </div>
    `;
};
